export enum EOverlayType {
    TEXT = 'text',
    MASK = 'mask',
    IMAGE = 'image',
    INCREASE = 'increase',
    DECREASE = 'decrease',
}
